import {
  post,
  get
} from './http'
import global from '@/api/global'
// var name = 'wmsAccess'
var name = global.wmsStockName
var signature = global.signature
var wmsCenter = global.wmsCenter
var smpName = global.smpName
var vgsName = 'vgs-driver-server2/driver2'
const crm = global.crm
var crmServer3 = global.crmServer3
const stockname = global.stockName

// 监管盘库盘库人下拉选
export const pankuren = p => post(crmServer3 + `/sUser/list`, p) // 月度账单 查询

// 货物类型 -云单证
export const getDictionaryAll = p => post(`/${name}/b/dictionary/getDictionaryAll`, p) // 月度账单 查询

// 客户列表crm3
export const getRelationCustomerCrm3 = p => post(`${crmServer3}/sCustomer/list`, p)
// 盘库结算
export const getFeeMonthList = p => post(`/${name}/inventory/getFeeMonthList`, p) // 月度账单 查询
export const addFeeMonthRemark = p => post(`/${name}/inventory/addFeeMonthRemark`, p) // 月度账单 添加备注
export const getFeeMonthDetailedList = p => post(`/${name}/inventory/getFeeMonthDetailedList`, p) // 月度账单 月度账单明细查询
export const getDivideFeeList = p => post(`/${name}/inventory/getDivideFeeList`, p) // 月度账单 分成查询
export const getInventoryFeeList = p => post(`/${name}/inventory/getInventoryFeeList`, p) // 月度账单 账单明细查询
export const getFeeMasterTotal = p => post(`/${name}/storageFee/getFeeMasterTotal`, p) // 月度账单 账单明细查询

// 盘库管理
export const getInventoryList = p => post(`/${name}/inventory/getInventoryList`, p) // 查询
export const getInventoryNumber = p => post(`/${name}/inventory/getInventoryNumber`, p) // 重量
export const addInventory = p => post(`/${name}/inventory/addInventory`, p) // 提交盘库
export const deleteInventory = p => post(`/${name}/inventory/deleteInventoryCargo`, p) // 删除

// 盘库订单
export const getInventoryOrderList = p => post(`/${name}/inventory/getInventoryOrderList`, p) // 查询
export const getInventoryGoodsList = p => post(`/${name}/inventory/getInventoryGoodsList`, p) // 货物查询
export const getInventoryPersonList = p => post(`/${name}/inventory/getInventoryPersonList`, p) // 人员查询
export const deleteNoInventoryOrder = p => post(`/${name}/inventory/deleteNoInventoryOrder`, p) // 作废
export const deleteInventoryOrder = p => post(`/${name}/inventory/deleteInventoryOrder`, p) // 删除
export const finishInventoryList = p => post(`/${name}/inventory/finishInventoryList`, p) // 盘货完成

// 盘库建材
export const getInventoryJFList = p => post(`/${name}/inventory/getInventoryJFList`, p) // 主列表
export const getInventoryJFNumber = p => post(`/${name}/inventory/getInventoryJFNumber`, p) // 重量
export const getInventoryJFGoodsList = p => post(`/${name}/inventory/getInventoryJFGoodsList`, p) // 货物
export const addInventoryThread = p => post(`/${name}/inventory/addInventoryThread`, p) // 盘货

// 封垛管理
export const getBinList = p => post(`/${name}/warehouse/getBinList`, p) // 查询
export const addBinList = p => post(`/${name}/warehouse/addBinList`, p) // 添加
export const deleteBinList = p => post(`/${name}/warehouse/deleteBinList`, p) // 解封

// 提单作业判断是否创建出库计划
export const getBillOutM = p => post(`/${name}/bill/getBillOutM`, p)
export const finishBill = p => post(`/${name}/bill/finishBill`, p)
// 云单证待进仓报表
export const getInWarehousingList = p => post(`/${name}/recordDetails/getInWarehousingList`, p)
export const getInWarehousingNumber = p => post(`/${name}/recordDetails/getInWarehousingNumber`, p)
export const getInStockList = p => post(`/${name}/recordDetails/getInStockList`, p)
export const getInStockListAllWeight = p => post(`/${name}/recordDetails/getInStockListAllWeight`, p)

// 仓位导入
export const importWlb = p => post(`/${name}/warehouse/importWlb`, p)

// 识别转货单
export const ocrCustomModelByFile = p => post(`/${signature}/api/ocrCustomModelByFile`, p)
export const ocrModelList = p => post(`/${signature}/api/ocrModelList`, p)
export const oCrAnalysisChangeDetail = p => post(`/${name}/change/oCrAnalysisChangeDetail`, p)
export const updateChangeCargoBarcode = p => post(`/${name}/change/updateChangeCargoBarcode`, p)

// 库存报表国铁
export const getWhStockInfoCargoListGT = p => post(`/${name}/recordDetails/getWhStockInfoCargoList`, p)

// 查看提货凭证
export const getSBillFileUrl = p => post(`/${stockname}/sBill/getSBillFileUrl`, p)

// 司机人车信息
export const findDriverByIdentityNo = p => post(`/${vgsName}/api/findDriverByIdentityNoApp`, p)
export const findVhcByVhcNo = p => post(`/${vgsName}/api/findVhcByVhcNoApp`, p)

// 字典客户
export const getRelationCustomer = p => post(`/${name}/instock/getRelationCustomer`, p)
export const zidian = p => post(`/${name}/b/dictionary/getDictionary`, p)
export const zidianKuwei = p => post(`/${name}/instock/findWarehouses`, p)
export const zidianQuwei = p => post(`/${name}/instock/findLocation`, p)
export const zidianHuowei = p => post(`/${name}/instock/findBin`, p)
// 基础信息维护
export const getVirtualBalingList = p => post(`/${name}/virtualBaling/getVirtualBalingList`, p) // 基础列表查询
export const addOrUpdateVirtualBaling = p => post(`/${name}/virtualBaling/addOrUpdateVirtualBaling`, p) // 基础物料新增或修改
export const deleteVirtualBaling = p => post(`/${name}/virtualBaling/deleteVirtualBaling`, p) // 出库记录
export const getPlaceOfOriginList = p => post(`/${name}/virtualBaling/getPlaceOfOriginList`, p) // 出库记录
export const importVirtualBaling = p => post(`/${name}/virtualBaling/importVirtualBaling`, p)

// 库存管理
export const getOutStockCargoRecordList = p => post(`/${name}/whInOutStockCargoRecord/getOutStockCargoRecordList`, p) // 出库记录
export const getOutStockGetReadyList = p => post(`/${name}/whInOutStockCargoRecord/getOutStockGetReadyList`, p) // 出库计划中
export const getInStockCargoRecordList = p => post(`/${name}/whInOutStockCargoRecord/getInStockCargoRecordList`, p) // 入库记录
export const getWhStockInfoCargoList = p => post(`/${name}/whOperationManage/getWhStockInfoCargoList`, p)
export const delCargoInfo = p => post(`/${name}/whOperationManage/deleteCargoInfo`, p)
export const updateCargoInfo = p => post(`/${name}/whOperationManage/updateCargoInfo`, p)
export const remarkChanges = p => post(`/${name}/whOperationManage/remarkChanges`, p)
export const changeWhCargoCustomer = p => post(`/${name}/whOperationManage/changeWhCargoCustomer`, p)
export const getWhAllStockInfoCargoList = p => post(`/${name}/whOperationManage/getWhAllStockInfoCargoList`, p)
export const getWhStockDeleteRecordList = p => post(`/${name}/whOperationManage/getWhStockDeleteRecordList`, p)
export const exportStockInfoCargoList = p => post(`/${name}/whOperationManage/exportStockInfoCargoList`, p)
export const warehouseCargoKaiping = p => post(`/${name}/whOperationManage/warehouseCargoKaiping`, p)
export const changeNewsInfo = p => post(`/${name}/whOperationManage/changeNewsInfo`, p)
export const exportAllStockInfoCargoList = p => post(`/${name}/whOperationManage/exportAllStockInfoCargoList`, p)
// export const getWhAllStockInfoCargoListAllWeight = p => post(`/${name}/whOperationManage/getWhAllStockInfoCargoListAllWeight`, p)
export const getOutStockCargoRecordListAllWeight = p => post(`/${name}/whInOutStockCargoRecord/getOutStockCargoRecordListAllWeight`, p)
export const getOutStockGetReadyListAllWeight = p => post(`/${name}/whInOutStockCargoRecord/getOutStockGetReadyListAllWeight`, p)
export const getInWhAllStockInfoCargoListAllWeight = p => post(`/${name}/whOperationManage/getInWhAllStockInfoCargoListAllWeight`, p)
export const getOutWhAllStockInfoCargoListAllWeight = p => post(`/${name}/whOperationManage/getOutWhAllStockInfoCargoListAllWeight`, p)
export const importDateCutting = p => post(`/${name}/whOperationManage/importDateCutting`, p)

// export const getInventoryList = p => post(`/${name}/whOperationManage/getInventoryList`, p)
export const getCustomerInstock = p => post(`/${name}/whOperationManage/getCustomerInstock`, p) // 客户库存
export const getCustomerInstockSummary = p => post(`/${name}/whOperationManage/getCustomerInstockSummary`, p) // 库存明细
export const confirmChangeCargoRight = p => post(`/${name}/whOperationManage/confirmChangeCargoRight`, p) // 客户库存-确认
export const getNewsInfo = p => post(`/${name}/whOperationManage/getNewsInfo`, p)
export const importCargoInfo = p => post(`/${name}/whOperationManage/importCargoInfo`, p) // 数据切割导入
export const updateJFInStockNo = (q) => post(`/${name}/whOperationManage/updateJFInStockNo`, q) // 修改进仓单号
export const updateJFOutStockNo = (q) => post(`/${name}/whOperationManage/updateJFOutStockNo`, q) // 修改出仓单号
// 仓位维护
export const findWarehouseList = p => post(`/${name}/warehouse/findWarehouseList`, p)
export const findLocationList = p => post(`/${name}/warehouse/findLocationList`, p)
export const findBinList = p => post(`/${name}/warehouse/findBinList`, p)
export const operationWarehouse = p => post(`/${name}/warehouse/operationWarehouse`, p)
export const selectUpWarehouse = p => post(`/${name}/warehouse/selectUpWarehouse`, p)
export const selectWarehouse = p => post(`/${name}/warehouse/selectWarehouse`, p)
export const xiuGaiWarehouse = p => post(`/${name}/warehouse/operationWarehouse`, p)
export const delWarehouse = p => post(`/${name}/warehouse/deleteWarehouse`, p)
export const operationLocation = p => post(`/${name}/warehouse/operationLocation`, p)
export const selectUpLocation = p => post(`/${name}/warehouse/selectUpLocation`, p)
export const xiuGaiLocation = p => post(`/${name}/warehouse/operationLocation`, p)
export const delLocation = p => post(`/${name}/warehouse/deleteLocation`, p)
export const operationBin = p => post(`/${name}/warehouse/operationBin`, p)
export const selectUpBin = p => post(`/${name}/warehouse/selectUpBin`, p)
export const xiuGaiOperationBin = p => post(`/${name}/warehouse/operationBin`, p)
export const delBin = p => post(`/${name}/warehouse/deleteBin`, p)
// 仓位停车位
export const getParkingList = p => post(`/${name}/parkingSpace/list`, p) // 车位列表
export const addParkingSpace = p => post(`/${name}/parkingSpace/add`, p) // 添加确定
export const getParkingDetail = p => post(`/${name}/parkingSpace/detail`, p) // 修改时查询停车位详细信息
export const updateParkingSpace = p => post(`/${name}/parkingSpace/update`, p) // 修改保存
export const deleteParkingSpace = p => post(`/${name}/parkingSpace/delete`, p) // 删除
export const getParkingPosSpace = p => post(`/${name}/parkingLocationSpace/list`, p) // 车位位置列表
export const addParkingPosSpace = p => post(`/${name}/parkingLocationSpace/add`, p) // 添加位置确定
export const getParkingPosDetail = p => post(`/${name}/parkingLocationSpace/detail`, p) // 修改时查询停车位位置详细信息
export const updateParkingPos = p => post(`/${name}/parkingLocationSpace/update`, p) // 修改保存
export const deleteParkingPos = p => post(`/${name}/parkingLocationSpace/delete`, p) // 删除

// 货权变更
export const findChangeDetailWN = p => post(`/${name}/change/findChangeDetailWN`, p) // 变更作业重量件数
export const findChangeList = p => post(`/${name}/change/findChangeMasterList`, p)
export const tianjiaChangeList = p => post(`/${name}/change/operationChangeMaster`, p)
export const findXgChangeList = p => post(`/${name}/change/selectUpChangeMaster`, p)
export const xiugaiChangeList = p => post(`/${name}/change/operationChangeMaster`, p)
export const changeListDel = p => post(`/${name}/change/deleteChangeMaster`, p)
export const applyChangeMaster = p => post(`/${name}/change/applyChangeMaster`, p)
export const addChangeDetail = p => post(`/${name}/change/findStockList`, p)
export const addChangeDetailOk = p => post(`/${name}/change/addChangeDetail`, p)
export const findChangeDetailList = p => post(`/${name}/change/findChangeDetailList`, p)
export const delChangeDetailList = p => post(`/${name}/change/deleteChangeDetailList`, p)
export const saveChangeMasterPicture = p => post(`/${name}/change/saveChangeMasterPicture`, p)
export const getPictureShow = p => post(`/${name}/change/getPictureShow`, p)
export const delPicture = p => post(`/${name}/change/delPicture`, p)
export const findCustomerChangesList = p => post(`/${name}/change/findCustomerChangesList`, p)
export const ownerConfirmChange = p => post(`/${name}/change/ownerConfirmChange`, p)
export const ownerConfirmreJection = p => post(`/${name}/change/ownerConfirmreJection`, p)
export const printChangeResume = p => post(`/${name}/change/printChangeResume`, p)
export const revokeChangeMaster = p => post(`/${name}/change/revokeChangeMaster`, p) // 变更撤回
export const cancelChange = p => post(`/${name}/change/cancelChange`, p) // 变更撤回

// spu
export const productSpuList = p => post(`/${name}/productSpu/productSpuList`, p)
export const productSpuFieldList = p => post(`/${name}/productSpu/productSpuFieldList`, p)
export const productSpuAdd = p => post(`/${name}/productSpu/productSpuAdd`, p)
export const productSpuUpdate = p => post(`/${name}/productSpu/productSpuUpdate`, p)
export const productSpuDelete = p => post(`/${name}/productSpu/productSpuDelete`, p)
export const productSpuFieldAdd = p => post(`/${name}/productSpu/productSpuFieldAdd`, p)
export const productSpuFieldUpdate = p => post(`/${name}/productSpu/productSpuFieldUpdate`, p)
export const productSpuCopyAdd = p => post(`/${name}/productSpu/productSpuCopyAdd`, p)
// 提货作业
export const findBillMasterList = p => post(`/${name}/bill/findBillMasterList`, p)
export const findBillDetailList = p => post(`/${name}/bill/findBillDetailList`, p)
export const addWhOutstockMaster = p => post(`/${name}/bill/addWhOutstockMaster`, p)
export const addWhOutstockMasterForHz = p => post(`/${name}/bill/addWhOutstockMasterForHz`, p) // 货主出库单
export const getBillType = p => post(`/${name}/bill/getBillType`, p) // 货主出库单
export const checkBill = p => post(`/${name}/bill/checkBill`, p)
export const createChange = p => post(`/${name}/bill/createChange`, p)
export const feedback = p => post(`/${name}/bill/feedback`, p)
export const toVoid = p => post(`/${name}/bill/toVoid`, p)
export const getPdfShow = p => post(`/${name}/bill/getPdfShow`, p)
export const uploadVoucher = p => post(`/${name}/bill/uploadVoucher`, p)
//  字典维护
export const getDictionaryList = p => post(`/${name}/dictionary/getDictionaryList`, p)
export const getGroupNos = p => post(`/${name}/dictionary/getGroupNos`, p)
export const insertDictionary = p => post(`/${name}/dictionary/insertDictionary`, p)
export const getDictionaryForUpdate = p => post(`/${name}/dictionary/getDictionaryForUpdate`, p)
export const updateDictionary = p => post(`/${name}/dictionary/updateDictionary`, p)
export const deleteDictionary = p => post(`/${name}/dictionary/deleteDictionary`, p)
// 货权反馈
export const huoQuan = p => post(`/${name}/pl3Stock/selectChangeFeedbackList`, p)
export const selectChangeFeedBack = p => post(`/${name}/pl3Stock/selectChangeFeedBack`, p)
export const printChange = p => post(`/${name}/change/printChange`, p)
export const printChangeList = p => post(`/${name}/change/printChangeList`, p)// 变更作业多条打印
export const changeFeedback = p => post(`/${name}/pl3Stock/changeFeedback`, p)
export const changeAndOutFeedback = p => post(`/${name}/pl3Stock/changeAndOutFeedback`, p)
export const selectAlllWeight = p => post(`/${name}/pl3Stock/selectAlllWeight`, p)
// // 仓储大屏
// export const selectStockChart = p => post(`/${name}/warehouseDataDisplay/selectStockChart`, p) // 1-饼图
// export const selectDayInOutStock = p => post(`/${name}/warehouseDataDisplay/selectDayInOutStock`, p) // 2-柱状图
// export const getInOutStockList = p => post(`/${name}/warehouseDataDisplay/getInOutStockList`, p) // 3-出入库作业列表
// export const getDayInOutForWaveform = p => post(`/${name}/warehouseDataDisplay/getDayInOutForWaveform`, p) // 4- 日出入库波动统计
// export const getTWhStatisticsStockList = p => post(`/${name}/warehouseDataDisplay/getTWhStatisticsStockList`, p) // 5-日库存量波动统计
// export const getLatheoperatorMap = p => post(`/${name}/warehouseDataDisplay/getLatheoperatorMap`, p) // 2.6 天车工作业统计
// export const getStatisticsMap = p => post(`/${name}/warehouseDataDisplay/getStatisticsMap`, p) // 2.7 统计员作业统计
export const selectStockChart = p => post(`/${wmsCenter}/warehouseDataDisplay/selectStockChart`, p) // 1-饼图
export const selectDayInOutStock = p => post(`/${wmsCenter}/warehouseDataDisplay/selectDayInOutStock`, p) // 2-柱状图
export const getInOutStockList = p => post(`/${wmsCenter}/warehouseDataDisplay/getInOutStockList`, p) // 3-出入库作业列表
export const getDayInOutForWaveform = p => post(`/${wmsCenter}/warehouseDataDisplay/getDayInOutForWaveform`, p) // 4- 日出入库波动统计
export const getTWhStatisticsStockList = p => post(`/${wmsCenter}/warehouseDataDisplay/getTWhStatisticsStockList`, p) // 5-日库存量波动统计
export const getLatheoperatorMap = p => post(`/${wmsCenter}/warehouseDataDisplay/getLatheoperatorMap`, p) // 2.6 天车工作业统计
export const getStatisticsMap = p => post(`/${wmsCenter}/warehouseDataDisplay/getStatisticsMap`, p) // 2.7 统计员作业统计
// 出入库明细
export const getInStockInfoCargoRecordList = p => post(`/${name}/whInOutStockCargoRecord/getInStockInfoCargoRecordList`, p) // 1.入库明细数据
export const getOutStockCargoDetailList = p => post(`/${name}/whInOutStockCargoRecord/getOutStockCargoDetailList`, p) // 1.入库明细数据--

// 公共方法-查看审核进度
export const findcFlowAuditLogByFormId = p => post(`/${signature}/api/flow/findcFlowAuditLogByFormId`, p) // 1.入库明细数据--
export const auditFlow = p => post(`/${signature}/api/flow/auditFlow`, p) // 审批作业-同意-审批流
export const confirmChangeMaster = p => post(`/${name}/change/confirmChangeMaster`, p) // 审批作业-同意-审批流
export const noConfirmChangeMaster = p => post(`/${name}/change/noConfirmChangeMaster`, p) // 审批作业-驳回-审批流
export const selectAgencyTask = p => post(`/${name}/change/selectAgencyTask`, p) // 审批作业
export const clearCustomerInstockSummary = p => post(`/${name}/whOperationManage/clearCustomerInstockSummary`, p) // 审批作业
export const updateCustomerInstockSummaryInstockDate = p => post(`/${name}/whOperationManage/updateCustomerInstockSummaryInstockDate`, p) // 审批作业
// 变更明细
export const getFalseChangeDetailList = p => post(`/${name}/change/getFalseChangeDetailList`, p)
// j结算
export const getCostSettlementWarehouse = p => post(`/${name}/settlement/getCostSettlementWarehouse`, p) // 仓储费
export const getCostSettlementOverdue = p => post(`/${name}/settlement/getCostSettlementOverdue`, p) // 超期费
export const getCostSettlementChange = p => post(`/${name}/settlement/getCostSettlementChange`, p) // 过户费
export const getCostSettlementtHoisting = p => post(`/${name}/settlement/getCostSettlementtHoisting`, p) // 吊装费

export const updateOverduePaymentCustomer = p => post(`/${name}/settlement/updateOverduePaymentCustomer`, p) // 超期费-变更
export const updateWarehousePaymentCustomer = p => post(`/${name}/settlement/updateWarehousePaymentCustomer`, p) // 仓储费-变更
export const updateChangePaymentCustomer = p => post(`/${name}/settlement/updateChangePaymentCustomer`, p) // 过户费-变更
export const updateHoistingPaymentCustomer = p => post(`/${name}/settlement/updateHoistingPaymentCustomer`, p) // 吊装费-变更
export const getCostSettlementOutStock = p => post(`/${name}/settlement/getCostSettlementOutStock`, p) // 出库费-数据
export const updateOutStockPaymentCustomer = p => post(`/${name}/settlement/updateOutStockPaymentCustomer`, p) // 出库费-变更
export const getTallyInfoList = p => post(`/${name}/whOperationManage/getTallyInfoList`, p) // 理货记录
export const getOutstockCancellationRecordList = p => post(`/${name}/whOperationManage/getOutstockCancellationRecordList`, p) // 出库撤销记录
export const saveSplitSpecification = p => post(`/${name}/whOperationManage/saveSplitSpecification`, p) // 出库撤销记录
// 波动预警
export const getCustomerInstockWave = p => post(`/${name}/whOperationManage/getCustomerInstockWave`, p) // 入库
export const getCustomerOutstockWave = p => post(`/${name}/whOperationManage/getCustomerOutstockWave`, p) // 出库
export const getCustomerInstockSummaryZero = p => post(`/${name}/whOperationManage/getCustomerInstockSummaryZero`, p) // 零库存
// 天车工统计
export const getLatheoperatorMapForWeb = p => post(`/${name}/warehouseDataDisplay/getLatheoperatorMapForWeb`, p)
// 智能仓
export const findPositionForAI = p => post(`/${name}/instock/findPositionForAI`, p)
// 出入统计
export const getInOutForOrgId = p => post(`/${name}/warehouseDataDisplay/getInOutForOrgId`, p)
// 园区维护-
export const parkList = p => post(`/${name}/park/list`, p) // 1-列表
export const parkAdd = p => post(`/${name}/park/add`, p) // 2-新增
export const parkUpdate = p => post(`/${name}/park/update`, p) // 3-修改
export const parkDetail = p => post(`/${name}/park/detail`, p) // 4-修改查询
export const parkDelete = p => post(`/${name}/park/delete`, p) // 5-删除
export const parkGetParkList = p => post(`/${name}/park/getParkList`, p) // 6-获取园区下拉框
// 设备档案
export const findEquipmentList = p => post(`/${name}/equipment/findEquipmentList`, p) // 1-列表
export const addOrUpdateEquipment = p => post(`/${name}/equipment/addOrUpdateEquipment`, p) // 2-新增、修改
export const findEquipment = p => post(`/${name}/equipment/findEquipment`, p) // 4-修改查询
export const deleteEquipment = p => post(`/${name}/equipment/deleteEquipment`, p) // 5-删除
// 备件清单
export const findSparePartList = p => post(`/${name}/spare/findSparePartList`, p) // 列表
export const addOrUpdateSparePart = p => post(`/${name}/spare/addOrUpdateSparePart`, p) // 新增/修改
export const deleteSparePart = p => post(`/${name}/spare/deleteSparePart`, p) // 删除
export const importSparePart = p => post(`/${name}/spare/importSparePart`, p) // 导入
// 人员打卡
export const findPersonnelPunchClockList = p => post(`/${name}/personnel/findPersonnelPunchClockList`, p) // 列表
export const addPersonnelPunchClockPC = p => post(`/${name}/personnel/addPersonnelPunchClockPC`, p) // 新增
export const updatePersonnelPunchClockPC = p => post(`/${name}/personnel/updatePersonnelPunchClockPC`, p) /// 修改 删除
// 点检项目设置
export const getDictionary = p => post(`/${name}/b/dictionary/getDictionary`, p) // 字典
export const tCheckItemsInfoList = p => post(`/${name}/tCheckItemsInfo/list`, p) // 列表
export const tCheckItemsInfoAdd = p => post(`/${name}/tCheckItemsInfo/add`, p) // 列表-新增
export const tCheckItemsInfoDetail = p => post(`/${name}/tCheckItemsInfo/detail`, p) // 列表-修改查询
export const tCheckItemsInfoUpdate = p => post(`/${name}/tCheckItemsInfo/update`, p) // 列表-修改
export const tCheckItemsInfoDelete = p => post(`/${name}/tCheckItemsInfo/delete`, p) // 列表-删除
// 设备点检
export const getEquipmentCheckMasterList = p => post(`/${name}/tCheckItemsInfo/getEquipmentCheckMasterList`, p) // 列表
export const getEquipmentCheckDetailList = p => post(`/${name}/tCheckItemsInfo/getEquipmentCheckDetailList`, p) // 列表-详情
export const getEquipmentUpdate = p => post(`/${name}/tCheckItemsInfo/update`, p) // 列表-详情
// 现场巡检
export const getSceneInspectionList = p => post(`/${name}/tCheckItemsInfo/getSceneInspectionList`, p) // 列表
export const getDictionaryIn = p => post(`/${name}/b/dictionary/getDictionary`, p) // 列表
export const getImgShow = p => post(`/${name}/tWhImg/getImgShow`, p) // 列表-图片
// 维修审核
export const findeRepairListPC = p => post(`/${name}/equipment/findeRepairListPC`, p) // 列表
export const submitRepairMaintenancePC = p => post(`/${name}/equipment/submitRepairMaintenancePC`, p) // 列表-修改提交
export const findeRepairPC = p => post(`/${name}/equipment/findeRepairPC`, p) // 列表-审核查询
export const submitRepairPC = p => post(`/${name}/equipment/submitRepairPC`, p) // 列表-审核提交
export const findAuditPC = p => post(`/${name}/equipment/findAuditPC`, p) // 列表-审核记录
export const findeRepairedPC = p => post(`/${name}/equipment/findeRepairedPC`, p) // 列表-处理记录
// 打包记录
export const getPackagRecordList = p => post(`/${name}/packag/getPackagRecordList`, p) // 列表-审核/处理记录
export const selectSpuAttributeList = p => post(`${smpName}/spuinfo/selectSpuAttributeList`, p) // 列表-审核/处理记录
export const updatePackagRecord = p => post(`${name}/packag/updatePackagRecord`, p) // 列表-审核/处理记录
export const tPackagTeamList = p => post(`${name}/tPackagTeam/list`, p) // 班组列表
export const tPackagTeamAdd = p => post(`${name}/tPackagTeam/add`, p) // 班组列表-新增
export const tPackagTeamDet = p => post(`${name}/tPackagTeam/delete`, p) // 班组列表-删除
export const getBzModeList = p => post(`${name}/packag/getBzModeList`, p) // 包装方式
export const getPackagTeamList = p => post(`${name}/packag/getPackagTeamList`, p) // 包装方式
export const importPackagRecord = p => post(`${name}/packag/importPackagRecord`, p) // 包装方式-导入
export const addPackagRecord = p => post(`${name}/packag/addPackagRecord`, p) // 包装方式-新增
export const deletePackagRecord = p => post(`${name}/packag/deletePackagRecord`, p) // 包装方式-删除
// 加工报表
export const getMachiningProductDetailList = p => post(`${name}/machiningReport/getMachiningProductDetailList`, p) // 加工成品/验收明细列表
export const getEntrustMaterialList = p => post(`${name}/machiningReport/getEntrustMaterialList`, p) // 原料信息查询
export const getProductChecklList = p => post(`${name}/machiningReport/getProductChecklList`, p) // 成品信息查询
export const getProductionlineReport = p => post(`${name}/tProductionlineReport/list`, p) // 加工产线报表 列表

// 加工委托单
export const getMachiningEntrustList = p => post(`${name}/machining/getMachiningEntrustList`, p) // 列表
export const addOrUpdateMachiningEntrust = p => post(`${name}/machining/addOrUpdateMachiningEntrust`, p) // 新增、修改
export const getMachiningEntrustInfo = p => post(`${name}/machining/getMachiningEntrustInfo`, p) // 新增、修改查询
export const delMachiningEntrust = p => post(`${name}/machining/delMachiningEntrust`, p) // 作废
export const addMachiningNotice = p => post(`${name}/machining/addMachiningNotice`, p) // 生成加工通知单
export const submitRepairImage = p => post(`${name}/tWhImg/submitImage`, p) // 上传图片
export const updateImage = p => post(`${name}/tWhImg/update`, p) // 删除图片
// 加工排产
export const findSchedulingList = p => post(`${name}/scheduling/findSchedulingList`, p) // 列表
export const findSchedulingDetail = p => post(`${name}/scheduling/findSchedulingDetail`, p) // 排产弹窗
export const updateSchedulingDetail = p => post(`${name}/scheduling/updateSchedulingDetail`, p) // 2.3排产弹窗确认按钮
export const findSchedulingWareList = p => post(`${name}/scheduling/findSchedulingWareList`, p) // 2.4加工仓库下拉框查询（排产弹窗）
export const findEquipmentListP = p => post(`${name}/scheduling/findEquipmentList`, p) // 2.5产线设备下拉框查询（排产弹窗）
export const getUsersByTenantCode = p => post(`${name}/scheduling/getUsersByTenantCode`, p) // 2.6选择人员列表查询（排产弹窗）
export const cancelScheduling = p => post(`${name}/scheduling/cancelScheduling`, p) // 2.7排产作废
export const findSchedulingPrint = p => post(`${name}/scheduling/findSchedulingPrint`, p) // 2.8排产打印查询
export const findSchedulingDeail = p => post(`${name}/scheduling/findSchedulingDeail`, p) // 2.9加工排产详情
export const addMachiningAcceptance = p => post(`${name}/scheduling/addMachiningAcceptance`, p) // 2.9加工排产验收单
export const findEntrustProductList = p => post(`${name}/scheduling/findEntrustProductList`, p) // 2.10成品信息按钮
// 加工验收
export const findMachiningCheckList = p => post(`${name}/machiningCheck/findMachiningCheckList`, p) // 2.11加工验收列表查询
export const findCheckDel = p => post(`${name}/machiningCheck/cancelCheck`, p) // 2.12加工验收作废按钮
export const findCheckPrint = p => post(`${name}/machiningCheck/findCheckPrint`, p) // 2.13验收单打印查询
export const delCheckDistribution = p => post(`${name}/machiningCheck/delCheckDistribution`, p) // 2.14验收单货物删除
export const addOrUpdateCheckDistribution = p => post(`${name}/machiningCheck/addOrUpdateCheckDistribution`, p) // 2.15验收单货物新增或修改
export const findCheckDistribution = p => post(`${name}/machiningCheck/findCheckDistribution`, p) // 2.16验收页面/验收详情页查询
export const checkDistribution = p => post(`${name}/machiningCheck/checkDistribution`, p) // 2.17验收按钮
export const checkWeightEquals = p => post(`${name}/machiningCheck/checkWeightEquals`, p) // 保存
export const getCheckCargoBarcode = p => post(`${name}/machiningCheck/getCheckCargoBarcode`, p) // 保存
// 加工通知单
export const getMachiningNoticeList = p => post(`${name}/machining/getMachiningNoticeList`, p) // 加工通知单列表列表
export const delMachiningNotice = p => post(`${name}/machining/delMachiningNotice`, p) // 加工通知单列表作废
export const addMachiningScheduling = p => post(`${name}/machining/addMachiningScheduling`, p) // 加工通知单列表-生成排产单
// 配单
export const getMachiningNoticeInfo = p => post(`${name}/machining/getMachiningNoticeInfo`, p) // 加工通知单列表-配单详情
export const addNoticeDistributionForYl = p => post(`${name}/machining/addNoticeDistributionForYl`, p) // 配单详情-操作
export const addNoticeDistributionForCr = p => post(`${name}/machining/addNoticeDistributionForCr`, p) // 配单详情-插入
export const delNoticeDistributionForMaster = p => post(`${name}/machining/delNoticeDistributionForMaster`, p) // 配单详情-主删除
export const delNoticeDistributionForSon = p => post(`${name}/machining/delNoticeDistributionForSon`, p) // 配单详情-子删除
export const updateNoticeDistribution = p => post(`${name}/machining/updateNoticeDistribution`, p) // 配单详情-半成品修改
export const addNoticeDistributionForBcpjg = p => post(`${name}/machining/addNoticeDistributionForBcpjg`, p) // 配单详情-半成品操作
export const addNoticeDistributionForHb = p => post(`${name}/machining/addNoticeDistributionForHb`, p) // 配单详情-生成合包
export const updateMachiningNotice = p => post(`${name}/machining/updateMachiningNotice`, p) // 配单详情-提交
// 加工结算
export const getProcessStatementList = p => post(`${name}/processStatement/getProcessStatementList`, p) // 2.1加工结算单列表查询
export const exportProcessStatementList = p => post(`${name}/processStatement/exportProcessStatementList`, p) // 2.2加工结算单列表导出
export const getProcessStatementPrint = p => post(`${name}/processStatement/getProcessStatementPrint`, p) // 2.3加工结算单列表打印
export const getStatementDetails = p => post(`${name}/processStatement/getStatementDetails`, p) // 2.4加工结算单详情
export const updateUnitPrice = p => post(`${name}/processStatement/updateUnitPrice`, p) // 2.5加工结算单详情修改单价
export const collectFees = p => post(`${name}/processStatement/collectFees`, p) // 2.6加工结算单收费

// 记重方式
export const getWeighingMethodList = p => post(`/${name}/systemConfig/getWeighingMethodList`, p)
export const addOrUpdateWeighingMeth = p => post(`/${name}/systemConfig/addOrUpdateWeighingMethod`, p)
export const getWeighingMethodPopup = p => get(`/${name}/systemConfig/getWeighingMethodPopup`, p)
export const deleteWeighingMethod = p => post(`/${name}/systemConfig/deleteWeighingMethod`, p)

// 库存
export const getTStockSummaryAvailableNumber = p => post(`/${name}/tEmpty/getTStockSummaryAvailableNumber`, p)

export const getCmRecordList = p => post(`/${name}/stockExpInfo/getCmRecordList`, p) // 分货确认记录查询
export const JfgetInStockExpList = p => post(`/${name}/stockExpInfo/getInStockExpList`, p) // 入库记录列表查询
export const JfexportInStockExpList = p => post(`/${name}/stockExpInfo/exportInStockExpList`, p) // 入库记录列表导出
export const JfdeleteInStockExp = p => post(`/${name}/stockExpInfo/deleteInStockExp`, p) // 入库记录删除
export const JfdeleteOutStockExp = p => post(`/${name}/stockExpInfo/deleteOutStockExp`, p) // 出库记录撤销
export const JfgetConfirmedExpList = p => post(`/${name}/stockExpInfo/getConfirmedExpList`, p) // 进仓记录列表查询
export const JfexportConfirmedExpList = p => post(`/${name}/stockExpInfo/exportConfirmedExpList`, p) // 进仓记录列表导出
export const JfgetChangeStorkExpList = p => post(`/${name}/stockExpInfo/getChangeStorkExpList`, p) // 转货记录查询 未确认
export const JfrevokeChangeStorkExp = p => post(`/${name}/stockExpInfo/revokeChangeStorkExp`, p) // 转货记录撤销

export const JfgetChangeStorkExpNumber = p => post(`/${name}/stockExpInfo/getChangeStorkExpNumber`, p) // 转货总件数总吨数
export const jfgetDeleteOutStockExpList = p => post(`/${name}/stockExpInfo/getDeleteOutStockExpList`, p) // 撤销记录列表查询
export const jfgetCmRecordList = p => post(`/${name}/stockExpInfo/getCmRecordList`, p) // 进仓撤销记录列表查询
export const jfgetWarehouseClearList = p => post(`/${name}/stockExpInfo/getWarehouseClearList`, p) // 仓位亏涨记录列表查询
export const jfgetCustomerClearList = p => post(`/${name}/stockExpInfo/getCustomerClearList`, p) // 客户亏涨记录列表查询
export const jfgetTransferRecordExpList = p => post(`/${name}/stockExpInfo/getTransferRecordExpList`, p) // 移库记录列表查询
export const JfgetDeleteInStockExpList = p => post(`/${name}/stockExpInfo/getDeleteInStockExpList`, p) // 删除记录列表查询
export const JfexportDeleteInStockExpList = p => post(`/${name}/stockExpInfo/exportDeleteInStockExpList`, p) // 删除记录列表导出
export const JfgetOutStockExpList = p => post(`/${name}/stockExpInfo/getOutStockExpList`, p) // 出库记录列表查询
export const JfexportOutStockExpList = p => post(`/${name}/stockExpInfo/exportOutStockExpList`, p) // 出库记录列表导出
export const JfgetStockWarehouseList = p => post(`/${name}/stockThreadExp/getStockWarehouseList`, p) // 仓位库存列表查询
export const JfexportStockWarehouseList = p => post(`/${name}/stockThreadExp/exportStockWarehouseList`, p) // 仓位库存列表导出
export const JfclearStockWarehouse = p => post(`/${name}/stockThreadExp/clearStockWarehouse`, p) // 仓位库存盘盈盘亏
export const JfgetDistributionGoodsList = p => post(`/${name}/distributionGoods/getDistributionGoodsList`, p) // 分货确认列表查询 未确认
export const JfsecondDistributionGoods = p => post(`/${name}/distributionGoods/secondDistributionGoods`, p) // 二次分货
export const JfrevokeDistributionGoods = p => post(`/${name}/distributionGoods/revokeDistributionGoods`, p) // 撤销分货
export const JfconfirmDistributionGoods = p => post(`/${name}/distributionGoods/confirmDistributionGoods`, p) // 分货确认进仓
export const JfmodifyDistributionGoods = p => post(`/${name}/distributionGoods/modifyDistributionGoods`, p) // 分货修改客户
export const JfgetDistributionedGoodsList = p => post(`/${name}/distributionGoods/getDistributionedGoodsList`, p) // 分货确认列表查询 已确认

export const JfgetDistributionGoodsNumber = p => post(`/${name}/distributionGoods/getDistributionGoodsNumber`, p) // 分货总件数、总吨数
export const revokeConfirmDistributionGoods = p => post(`/${name}/distributionGoods/revokeConfirmDistributionGoods`, p) // 分货撤销

export const JftransferStockThread = p => post(`/${name}/stockThreadExp/transferStockThread`, p) // 仓位库存移库
export const JfimportStockWarehouse = p => post(`/${name}/stockThreadExp/importStockWarehouse`, p) // 仓位库存导入
export const JfgetStockWarehouseWN = p => post(`/${name}/stockThreadExp/getStockWarehouseWN`, p) // 仓位库存导入
export const JfgetStockCustomerList = p => post(`/${name}/stockThreadExp/getStockCustomerList`, p) // 客户库存查询
export const JfgetStockCustomerWN = p => post(`/${name}/stockThreadExp/getStockCustomerWN`, p) // 客户库存查询
export const JfexportStockCustomerList = p => post(`/${name}/stockThreadExp/exportStockCustomerList`, p) // 客户库存导出、
export const JfgetCustomerStock = p => post(`/${name}/stockThreadExp/getCustomerStock`, p) // 客户库存导出、

export const JfimportStockCustomer = p => post(`/${name}/stockThreadExp/importStockCustomer`, p) // 客户导入
export const JfclearStockCustomer = p => post(`/${name}/stockThreadExp/clearStockCustomer`, p) // 客户库存盘盈盘亏
export const JfgetCustomerAvailableNumber = p => post(`/${name}/tEmptyForJanFa/getCustomerAvailableNumber`, p) // 获取客户库存可转件数
export const JfgetStockWarehouseAvailableNumber = p => post(`/${name}/stockThreadExp/getStockWarehouseAvailableNumber`, p) // 获取仓位库存可移件数

export const JfaddOrUpdateStorageFee = p => post(`/${name}/storageFee/addOrUpdateStorageFee`, p) // 结算
export const JfgetStorageFeeList = p => post(`/${name}/storageFee/getStorageFeeList`, p) // 费用明细
export const updatePayCustomer = p => post(`/${name}/storageFee/updatePayCustomer`, p) // 费用明细 修改客户
export const JfgetFeeMasterList = p => post(`/${name}/storageFee/getFeeMasterList`, p) // 账单查询
export const getCollectRecordList = p => post(`/${name}/storageFee/getCollectRecordList`, p) // 收费记录
export const getCollectRecordAllfee = p => post(`/${name}/storageFee/getCollectRecordAllfee`, p) // 收费记录

export const getRefundRecordList = p => post(`/${name}/storageFee/getRefundRecordList`, p) // 退款记录
export const getRefundrecordAllfee = p => post(`/${name}/storageFee/getRefundrecordAllfee`, p) // 退款记录

export const JfcompleteStorageFee = p => post(`/${name}/storageFee/completeStorageFee`, p) // 结算完成
export const JfdeleteFeeMaster = p => post(`/${name}/storageFee/deleteFeeMaster`, p) // 结算删除
export const JfgetStorageFeeWeightAllfee = p => post(`/${name}/storageFee/getStorageFeeAllfee`, p) // 获取总数
export const getStorageFeeNumber = p => post(`/${name}/storageFee/getStorageFeeNumber`, p) // 费用明细获取总数
export const getFeeModeList = p => post(`/${name}/storageFee/getFeeModeList`, p) // 结算方式查询
export const revokeOrDelFeeMode = p => post(`/${name}/storageFee/modifyOrDelFeeMode`, p) // 结算方式修改或删除
export const addFeeMode = p => post(`/${name}/storageFee/addFeeMode`, p) // 结算方式添加
export const importFeeMode = p => post(`/${name}/storageFee/importFeeMode`, p) // 结算方式导入
export const getTPerFeeList = p => post(`/${name}/storageFee/getTPerFeeList`, p) // 预存管理查询
export const addTPerFee = p => post(`/${name}/storageFee/addTPerFee`, p) // 预存管理添加
export const DelTPerFee = p => post(`/${name}/storageFee/DelTPerFee`, p) // 预存管理删除
export const addPrestoreOrRefund = p => post(`/${name}/storageFee/addPrestoreOrRefund`, p) // 预存管理预存或退款
export const getDPreFeeList = p => post(`/${name}/storageFee/getDPreFeeList`, p) // 预存管理交易明细列表查询
export const getFeeList = p => post(`/${name}/storageFee/getFeeList`, p) // 账单管理账单明细

export const JfaddEmptyChangeExp = p => post(`/${name}/stockThreadExp/addEmptyChangeExp`, p) // 转货

// -------------建发出库-----------
// 出库提单
// 出库提单-新增-货物类型、产地、材质、规格、件数下拉框数据
export const JfgetTEmptyStockCustomerGroup = p => post(`/${name}/tEmptyForJanFa/getTEmptyStockCustomerGroup`, p)
// 出库提单-新增（来源手动）
export const JfaddEmptyBillJanFa = p => post(`/${name}/tEmptyForJanFa/addEmptyBillJanFa`, p)
// 出库提单-列表+新
export const JfgetTEmptyBillMasterList = p => post(`/${name}/tEmptyForJanFa/getTEmptyBillMasterList`, p)
export const getTEmptyBillMasterForList = p => post(`/${name}/tEmptyForJanFa/getTEmptyBillMasterForList`, p)
// 出库提单-货物明细列表
export const JfgetTEmptyBillDetailList = p => post(`/${name}/tEmptyForJanFa/getTEmptyBillDetailList`, p)
// 出库提单-修改出库提单 取得人车信息
export const JfgetTEmptyBillDriverList = p => post(`/${name}/tEmptyForJanFa/getTEmptyBillDriverList`, p)
// 出库提单-修改出库提单 取得货物明细列表
export const JfgetTEmptyBillDetailListForUp = p => post(`/${name}/tEmptyForJanFa/getTEmptyBillDetailListForUp`, p)
// 出库提单-修改保存（来源手动）
export const JfupEmptyBillJanFa = p => post(`/${name}/tEmptyForJanFa/upEmptyBillJanFa`, p)
// 出库提单-货物明细删除（来源手动）
export const JfdelEmptyBillDetailJanFa = p => post(`/${name}/tEmptyForJanFa/delEmptyBillDetailJanFa`, p)
// 出库提单-修改-提单相关的出库单已使用的人车信息
export const JfcheckBillDriverUse = p => post(`/${name}/tEmptyForJanFa/checkBillDriverUse`, p)
// 出库提单-出库提单 完成
export const JfcompleteTEmptyBillMasterJanFa = p => post(`/${name}/tEmptyForJanFa/completeTEmptyBillMasterJanFa`, p)
// 出库提单-出库提单 作废
export const JfcancelTEmptyBillMasterJanFa = p => post(`/${name}/tEmptyForJanFa/cancelTEmptyBillMasterJanFa`, p)
// 出库提单-添加出库计划 添加货物列表（来源手动）
export const JfgetEmptyBillStockWarehouse = p => post(`/${name}/tEmptyForJanFa/getEmptyBillStockWarehouse`, p)
// 出库提单-添加出库计划 添加货物列表（来源手动）
export const JfvirtualControlBean = p => post(`/${signature}/api/control/virtualControlBean`, p)
// 出库提单-添加出库计划确定
export const JfaddEmptyOutstockJanFaForBill = p => post(`/${name}/tEmptyForJanFa/addEmptyOutstockJanFaForBill`, p)
// 出库计划
// 出库计划-列表
export const getOutstockMasterListJanFa = p => post(`/${name}/tEmptyForJanFa/getOutstockMasterListJanFa`, p)
// 出库计划-子表
export const JfgetOutstockSummaryListJanFa = p => post(`/${name}/tEmptyForJanFa/getOutstockSummaryListJanFa`, p)
// 出库计划- 添加计划货物信息 仓位下拉框 & 客户库存Id
export const JfgetEmptyBillStockWarehouseInfo = p => post(`/${name}/tEmptyForJanFa/getEmptyBillStockWarehouseInfo`, p)
// 出库计划- 添加货物信息 仓位选择后 取得仓位可提件数
export const JfgetNumberForBillStockWarehouse = p => post(`/${name}/tEmptyForJanFa/getNumberForBillStockWarehouse`, p)
// 出库计划- 添加出库计划确定
export const JfaddEmptyOutstockJanFa = p => post(`/${name}/tEmptyForJanFa/addEmptyOutstockJanFa`, p)
// 出库计划- 查询出库单主表子表所有信息（打印、修改回显、确认出库回显用）
export const JfgetOutstockInfoJanFa = p => post(`/${name}/tEmptyForJanFa/getOutstockInfoJanFa`, p)
// 出库计划-修改出库计划
export const JfupdateWhOutstockMasterJanFa = p => post(`/${name}/tEmptyForJanFa/updateWhOutstockMasterJanFa`, p)
// 出库计划-修改出库计划-删除货物明细
export const JfdelTEmptyOutstockSummaryJanFa = p => post(`/${name}/tEmptyForJanFa/delTEmptyOutstockSummaryJanFa`, p)
// 出库计划-删除出库单
export const JfdelTEmptyOutstockMasterJanFa = p => post(`/${name}/tEmptyForJanFa/delTEmptyOutstockMasterJanFa`, p)
// 出库计划-确认出库
export const JfconfirmWhOutstockJanFa = p => post(`/${name}/tEmptyForJanFa/confirmWhOutstockJanFa`, p)
// 出库计划-确认出库数据渲染
export const JfgetOutstockInfoJanFaForConfirm = p => post(`/${name}/tEmptyForJanFa/getOutstockInfoJanFaForConfirm`, p)

// 手动添加提单：
export const addOrUpdateBill = p => post(`/${name}/bill/addOrUpdateBill`, p) // 提单管理 新增或修改提交按钮
export const getPickUpList = p => post(`/${name}/bill/getPickUpList`, p) // 提单管理 新增或修改提交按钮
export const deleteBill = p => post(`/${name}/bill/deleteBill`, p) // 提单管理 删除按钮
export const addBillOutStock = p => post(`/${name}/bill/addBillOutStock`, p) // 提单管理 创建出库单保存按钮
export const getBillWN = p => post(`/${name}/bill/getBillWN`, p) // 提单作业总重量

// 字典获取是否结算客户
export const getDictionaryJson = p => post(`/${name}/b/dictionary/getDictionaryDetail`, p)
// 建发报表中心
export const getWarehouseSummaryList = p => post(`/${name}/recordDetails/getWarehouseSummaryList`, p) // 建发-报表中心-汇总表
export const getPutInStorageList = p => post(`/${name}/recordDetails/getPutInStorageList`, p) // 入库记录建材列表查询
export const getPutInStorageNumber = p => post(`/${name}/recordDetails/getPutInStorageNumber`, p) // 入库记录建材总吨数总件数

export const getWarehousingList = p => post(`/${name}/recordDetails/getWarehousingList`, p) // 进仓记录建材列表查询
export const getWarehousingNumber = p => post(`/${name}/recordDetails/getWarehousingNumber`, p) // 进仓记录建材总吨数总件数

export const getOutExpList = p => post(`/${name}/recordDetails/getOutExpList`, p) // 出库记录建材列表查询
export const getOutExpNumber = p => post(`/${name}/recordDetails/getOutExpNumber`, p) // 出库记录建材总吨数总件数

export const getChangeList = p => post(`/${name}/recordDetails/getChangeList`, p) // 转货记录建材列表查询
export const getChangeNumber = p => post(`/${name}/recordDetails/getChangeNumber`, p) // 转货记录建材总吨数总件数

export const getJfWarehousingList = p => post(`/${name}/recordDetails/getJfWarehousingList`, p) // 进仓记录卷板列表查询
export const getJfWarehousingNumber = p => post(`/${name}/recordDetails/getJfWarehousingNumber`, p) // 进仓记录卷板总吨数总件数

export const getOutCargoList = p => post(`/${name}/recordDetails/getOutCargoList`, p) // 出库记录卷板列表查询
export const getOutCargoNumber = p => post(`/${name}/recordDetails/getOutCargoNumber`, p) // 出库记录卷板总吨数总件数

export const getChangesGoodsList = p => post(`/${name}/recordDetails/getChangesGoodsList`, p) // 转货记录卷板列表查询
export const getChangesGoodsNumber = p => post(`/${name}/recordDetails/getChangesGoodsNumber`, p) // 转货记录卷板总吨数总件数
export let findUserTenantRelList = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/api/findUserTenantRelList`, p)
  } else {
    return post(`${crm}/api/findUserTenantRelList`, p)
  }
}
// export const findUserTenantRelList = p => post(`${crm}/api/findUserTenantRelList`, p) // 仓库名称
// 建发-司机预提单
export const getTEmptyMiniBillMasterList = p => post(`/${name}/tEmptyForJanFaWeChat/getTEmptyMiniBillMasterList`, p)
// 建发-司机预提-删除
export const delEmptyMiniBillForWms = p => post(`/${name}/tEmptyForJanFaWeChat/delEmptyMiniBillForWms`, p)
// 建发-司机预提-添加货物列表(仓位库存)
export const getEmptyMiniBillStockWarehouse = p => post(`/${name}/tEmptyForJanFaWeChat/getEmptyMiniBillStockWarehouse`, p)
// ----------------------山西美景、安阳-------------------------
// 出仓提单-列表查询
export const getTEmptyBillChuCangList = p => post(`/${name}/tEmptyForJanFaChuCang/getTEmptyBillChuCangList`, p)
// 新增出仓提单 取得允许可提件数
export const getAvailableNumberChuCangBill = p => post(`/${name}/tEmptyForJanFaChuCang/getAvailableNumberChuCangBill`, p)
// 出仓提单 新增（来源手动）
export const addEmptyBillJanFaChuCang = p => post(`/${name}/tEmptyForJanFaChuCang/addEmptyBillJanFaChuCang`, p)
// 出仓提单 修改
export const upEmptyBillJanFaChuCang = p => post(`/${name}/tEmptyForJanFaChuCang/upEmptyBillJanFaChuCang`, p)
// 出仓提单 添加出库计划 添加货物列表(仓位库存)
export const getEmptyBillChuCangWarehouse = p => post(`/${name}/tEmptyForJanFaChuCang/getEmptyBillChuCangWarehouse`, p)
// 安阳、美锦库通过货物类型获取控货客户配置详细信息
export const getGoodControlInfo = p => post(`/${signature}/t/goods/control/master/getGoodControlInfo`, p)
// 出仓提单 添加出库计划 提单剩余量
export const getEmptyBillChuCangAvailable = p => post(`/${name}/tEmptyForJanFaChuCang/getEmptyBillChuCangAvailable`, p)
// 出仓提单 添加出库计划-确定
export const addEmptyOutstockJanFaForChuCangBill = p => post(`/${name}/tEmptyForJanFaChuCang/addEmptyOutstockJanFaForChuCangBill`, p)
// 取得出仓提单创建的出库计划 确认出库 货物信息未提量
export const getEmptyBillChuCangWeiTi = p => post(`/${name}/tEmptyForJanFaChuCang/getEmptyBillChuCangWeiTi`, p)
// 出库计划页面  出仓提单创建的出库计划 确认出库
export const confirmWhOutstockJanFaChuCang = p => post(`/${name}/tEmptyForJanFaChuCang/confirmWhOutstockJanFaChuCang`, p)
// 在库管理-转货保存
export const addEmptyChange = p => post(`${name}/stockThread/addEmptyChange`, p)
// 在库管理-上传单据
export const submitImage = p => post(`${name}/tWhImg/submitImages`, p)
// 在库管路-清零按钮
export const clearStockThread = p => post(`${name}/stockThread/clearStockThread`, p)
// 在库管理-总吨数、总件数
export const getStockThreadTotalWN = p => post(`${name}/stockThread/getStockThreadTotalWN`, p)
// 在库管理-删除单据
export const deleteImage = p => post(`${name}/tWhImg/deleteImage`, p)
export const addTransferLibrary = p => post(`/${name}/stockThread/addTransferLibrary`, p) // 出库总重量
export const surplusControlWeight = p => post(`${stockname}/api/surplusControlWeight`, p)
export const getCargoControlList = p => post(`/${name}/systemConfig/getCargoControlList`, p) // 控货客户查询
// 在库管理-货权方转货保存
export const addEmptyChangeForOwner = p => post(`${name}/stockThread/addEmptyChangeForOwner`, p)
// 在库管理-转给货权方保存
export const addEmptyChangeToOwner = p => post(`${name}/stockThread/addEmptyChangeToOwner`, p)
export const getCustomerAvailableNumber = p => post(`/${name}/tEmpty/getCustomerAvailableNumber`, p) // 客户库存可提件数
// ----------------------广州天又天--------------------
// 出库计划新增 人车信息 取得以前使用过的提货车号下拉框
export const getDriverList = p => post(`/${name}/tEmptyForJanFa/getDriverList`, p)
// 出库计划新增 添加货物列表 规格下拉框
export const getSpecificationListForSummary = p => post(`/${name}/tEmptyForJanFa/getSpecificationListForSummary`, p)
// 出库计划新增 添加货物列表 车船号下拉框
export const getPlateNumberListForSummary = p => post(`/${name}/tEmptyForJanFa/getPlateNumberListForSummary`, p)
// 出库计划新增 添加货物列表（在库库存）
export const getTStockSummaryList = p => post(`/${name}/tEmptyForJanFa/getTStockSummaryList`, p)
// 出库计划页面 新增出库计划确定
export const addEmptyOutstockJanFaForSummary = p => post(`/${name}/tEmptyForJanFa/addEmptyOutstockJanFaForSummary`, p)
// 查询出库计划主表id下的所有货物详情的过地磅记录（出库计划页面过磅&合磅用）
export const getEmptyWeightInfoListForOutstockId = p => post(`/${name}/tEmptyForJanFa/getEmptyWeightInfoListForOutstockId`, p)
// 出库计划页面 过磅与合磅保存
export const updateEmptyWeightInfoList = p => post(`/${name}/tEmptyForJanFa/updateEmptyWeightInfoList`, p)
// 查询出库单主表子表所有信息（确认出库回显用）
export const getOutstockInfoJanFaForConfirm = p => post(`/${name}/tEmptyForJanFa/getOutstockInfoJanFaForConfirm`, p)
// 出库计划页面 确认出库（船运预报编号、在库库存-库存汇总表出库）
export const confirmWhOutstockJanFaForSummary = p => post(`/${name}/tEmptyForJanFa/confirmWhOutstockJanFaForSummary`, p)
// 查询出库单主表子表所有信息（天又天打印、修改回显用）
export const getOutstockInfoJanFaForSummary = p => post(`/${name}/tEmptyForJanFa/getOutstockInfoJanFaForSummary`, p)
// 天又天修改出库计划 取得船运预报编号下拉框
export const getTStockSummaryGroupForShip = p => post(`/${name}/tEmptyForJanFa/getTStockSummaryGroupForShip`, p)
// 天又天修改出库计划 修改预报编号后
export const getNewTStockSummary = p => post(`/${name}/tEmptyForJanFa/getNewTStockSummary`, p)
// 天又天修改出库计划 修改预报编号后
export const updateEmptyOutstockJanFaForSummary = p => post(`/${name}/tEmptyForJanFa/updateEmptyOutstockJanFaForSummary `, p)
// 出库提单新增  添加货物列表（客户库存）
export const getTEmptyStockCustomerList = p => post(`/${name}/tEmptyForJanFa/getTEmptyStockCustomerList`, p)
// 出库提单添加出库计划 添加货物列表（来源手动 在库库存）
export const getEmptyBillStockForSummary = p => post(`/${name}/tEmptyForJanFa/getEmptyBillStockForSummary`, p)
// 出库提单添加出库计划确定(船运预报编号、在库库存-库存汇总表出库)
export const addEmptyOutstockJanFaForBillOfSummary = p => post(`/${name}/tEmptyForJanFa/addEmptyOutstockJanFaForBillOfSummary`, p)
// 出库记录撤销(广州天又天包含在库库存-库存汇总表)
export const deleteOutStockExpForSummary = p => post(`/${name}/stockExpInfo/deleteOutStockExpForSummary`, p)
// 出库记录总件数、总吨数查询
export const getOutStockExpNumber = p => post(`/${name}/stockExpInfo/getOutStockExpNumber`, p)
// 进仓记录总件数、总吨数查询
export const getConfirmedExpNumber = p => post(`/${name}/stockExpInfo/getConfirmedExpNumber`, p)
// 入库记录总件数、总吨数查询
export const getInStockExpNumber = p => post(`/${name}/stockExpInfo/getInStockExpNumber`, p)
// 天又天结算-费用结算新增保存
export const generatorChargeInfo = p => post(`/${name}/tEmptyForJanFaCharge/generatorChargeInfo`, p)
// 天又天结算-费用结算查询
export const getSettlementInfoList = p => post(`/${name}/tEmptyForJanFaCharge/getSettlementInfoList`, p)
// 天又天结算-费用结算结算单结算
export const doCharge = p => post(`/${name}/tEmptyForJanFaCharge/doCharge`, p)
// 天又天结算-费用结算作废
export const cancelSettlementInfo = p => post(`/${name}/tEmptyForJanFaCharge/cancelSettlementInfo`, p)
// 天又天结算-费用结算明细
export const getTEmptySettleInfo = p => post(`/${name}/tEmptyForJanFaCharge/getTEmptySettleInfo`, p)
// 天又天结算-费用结算明细
export const getChargeInfoListBySettleInfo = p => post(`/${name}/tEmptyForJanFaCharge/getChargeInfoListBySettleInfo`, p)
// 天又天结算-费用结算装卸费列表查询
export const getLoadingChargeDetailList = p => post(`/${name}/tEmptyForJanFaCharge/getLoadingChargeDetailList`, p)
// 天又天结算-费用结算超期费列表查询
export const getOverdueChargeDetailList = p => post(`/${name}/tEmptyForJanFaCharge/getOverdueChargeDetailList`, p)
// 天又天结算-费用结算转货费类表查询
export const getTransferChargeDetailList = p => post(`/${name}/tEmptyForJanFaCharge/getTransferChargeDetailList`, p)
// 加工2.0
export const getMachiningNoticeListTwo = p => post(`/${name}/machiningExp/getMachiningNoticeList`, p) // 加工计划列表
export const cancelPlanTwo = p => post(`/${name}/machiningExp/cancelPlan`, p) // 加工计划列表-作废
export const addOrUpdateMachiningPlanTwo = p => post(`/${name}/machiningExp/addOrUpdateMachiningPlan`, p) // 加工计划列表-新增/修改
export const getMachiningCargoListTwo = p => post(`/${name}/machiningExp/getMachiningCargoList`, p) // 加工计划配单-选择原料
export const addEntrustMaterialTwo = p => post(`/${name}/machiningExp/addEntrustMaterial`, p) // 加工计划配单-选择原料-确认
export const deleteEntrustMaterialTwo = p => post(`/${name}/machiningExp/deleteEntrustMaterial`, p) // 加工计划配单-选择原料-删除
export const addNoticeDistributionForYlTwo = p => post(`/${name}/machiningExp/addNoticeDistributionForYl`, p) // 加工计划配单-选择原料- 选择加工类型生成数据
export const addNoticeDistributionForBcpjgTwo = p => post(`/${name}/machiningExp/addNoticeDistributionForBcpjg`, p) // 加工计划配单-选择原料- 选择加工类型生成数据
export const addNoticeDistributionForHbTwo = p => post(`/${name}/machiningExp/addNoticeDistributionForHb`, p) // 加工计划配单-生成合包
export const delNoticeDistributionForMasterTwo = p => post(`/${name}/machiningExp/delNoticeDistributionForMaster`, p) // 加工计划配单-主删除
export const delNoticeDistributionForSonTwo = p => post(`/${name}/machiningExp/delNoticeDistributionForSon`, p) // 加工计划配单-子删除
export const addNoticeDistributionForCrTwo = p => post(`/${name}/machiningExp/addNoticeDistributionForCr`, p) // 加工计划配单-插入（除合包）
export const updateNoticeDistributionTwo = p => post(`/${name}/machiningExp/updateNoticeDistribution`, p) // 加工计划配单-半成品修改
export const findSchedulingPrintTwo = p => post(`/${name}/machiningExp/findSchedulingPrint`, p) // 加工计划配单-提交
export const updateMachiningNoticeTwo = p => post(`/${name}/machiningExp/updateMachiningNotice`, p) // 加工计划配单-提交
export const saveMachiningNoticeTwo = p => post(`/${name}/machiningExp/saveMachiningNotice`, p) // 加工计划配单-提交
export const getMachiningNoticeInfoTwo = p => post(`/${name}/machiningExp/getMachiningNoticeInfo`, p) // 加工计划配单-详情
export const getMachiningNoticeInfoDetailsTwo = p => post(`/${name}/machiningExp/getMachiningNoticeInfoDetails`, p) // 加工计划-详情
export const getEntrustMaterialListTwo = p => post(`/${name}/machiningExp/getEntrustMaterialList`, p) // 加工验收-主数据
export const findCheckDistributionTwo = p => post(`/${name}/machiningExp/findCheckDistribution`, p) // 加工验收-验收/详情页面
export const saveCheckAcceptanceTwo = p => post(`/${name}/machiningExp/saveCheckAcceptance`, p) // 加工验收-验收保存
export const getCheckCargoBarcodeTwo = p => post(`/${name}/machiningExp/getCheckCargoBarcode`, p) // 加工验收-添加获取捆包号
export const getCheckListTwo = p => post(`/${name}/machiningExp/getCheckList`, p) // 加工验收-主列表
export const cancelCheckTwo = p => post(`/${name}/machiningExp/cancelCheck`, p) // 加工验收-主列表
export const delCheckEntrustMaterialTwo = p => post(`/${name}/machiningExp/delCheckEntrustMaterial`, p) // 加工验收-加工前删除
export const delCheckDistributionTwo = p => post(`/${name}/machiningExp/delCheckDistribution`, p) // 加工验收-加工后删除
export const checkDistributionTwo = p => post(`/${name}/machiningExp/checkDistribution`, p) // 加工验收-确认验收
export const addCheckDistributionTwo = p => post(`/${name}/machiningExp/addCheckDistribution`, p) // 加工验收-添加
export const copyCheckDistributionTwo = p => post(`/${name}/machiningExp/copyCheckDistribution`, p) // 加工验收-复制
export const findCheckPrintTwo = p => post(`/${name}/machiningExp/findCheckPrint`, p) // 加工验收-复制
export const updatePriceTwo = p => post(`/${name}/processStatement/updatePrice`, p) // 加工结算
export const detailBId = p => post(`/${name}/t/wh/bin/detail`, p) // ru根据bid查找其他

export const getVideoUrl = p => post(`${name}/inventory/getVideoUrl`, p) // 安全帽获取视频回放第三方接口
export const jiankongToken = p => get(`${name}/inventory/getVideoToken`, p) // 安全帽获取视频回放第三方接口

// 云单证导出模板接口
export const exTemplatePutInStorageList = p => post(`${name}/recordDetails/exTemplatePutInStorageList`, p)
export const exTemplatePutInCargoStorageList = p => post(`${name}/recordDetails/exTemplatePutInCargoStorageList`, p)
export const exOutStockCargoRecordList = p => post(`${name}/whInOutStockCargoRecord/exOutStockCargoRecordList`, p)
export const exOutExpList = p => post(`${name}/recordDetails/exOutExpList`, p)
export const exTemplateStockInfoCargoList = p => post(`${name}/recordDetails/exTemplateStockInfoCargoList`, p)
export const exTemplateStockCustomerList = p => post(`${name}/stockThreadExp/exTemplateStockCustomerList`, p)
export const exTemplateChangeList = p => post(`${name}/recordDetails/exTemplateChangeList`, p)
export const exTemplateChangesGoodsList = p => post(`${name}/recordDetails/exTemplateChangesGoodsList`, p)
// 安全帽列表
export const getHatList = p => post(`${name}/inventory/getSafetyHatList`, p)
export const addHat = p => post(`${name}/inventory/addSafetyHat`, p)
export const modifySafetyHat = p => post(`${name}/inventory/modifySafetyHat`, p)
export const deleteHat = p => post(`${name}/inventory/delSafetyHat`, p)
// 入库作业中
export const getInStockIngCargoRecordList = p => post(`${name}/whInOutStockCargoRecord/getInStockIngCargoRecordList`, p)
export const getInStockIngCargoRecordListAllWeight = p => post(`${name}/whInOutStockCargoRecord/getInStockIngCargoRecordListAllWeight`, p)
// 变更履历
export const addNewJfInstockNoList = p => post(`${name}/change/addNewJfInstockNoList`, p)
export const findChangesWeight = p => post(`${name}/change/findChangesWeight`, p)// 重量
// 库存统计
export const getWhStockInfoCargoGroupList = p => post(`${name}/whInOutStockCargoRecord/getWhStockInfoCargoGroupList`, p)
// 忠信库进仓记录
export const getWarehousingRecordList = p => post(`${name}/warehouse/getWarehousingRecordList`, p) // 入库进仓列表
export const getWarehousingRecordNumber = p => post(`${name}/warehouse/getWarehousingRecordNumber`, p) // 入库进仓重量
export const getTransferRecordList = p => post(`${name}/warehouse/getTransferRecordList`, p) // 转货进仓列表
export const getTransferRecordNumber = p => post(`${name}/warehouse/getTransferRecordNumber`, p) // 转货进仓重量

// 建材结算相关接口
export const checkZkdJcFeeNameYesOrNo = p => post(`${name}/stockThreadExp/checkZkdJcFeeNameYesOrNo`, p) // 校验周口店模式建材结算开关是否已开启，并且已配置对应费目
export const getTransferCostUnitPrice = p => post(`${name}/stockThreadExp/getTransferCostUnitPrice`, p) // 转货申请取得过户费用单价
export const addEmptyChangeExp = p => post(`${name}/stockThreadExp/addEmptyChangeExp`, p) // 结算转货
export const getStorageFeeList = p => post(`${name}/tEmptyForJanFa/getStorageFeeList`, p) // 出库
export const confirmWhOutstockJanFa = p => post(`${name}/tEmptyForJanFa/confirmWhOutstockJanFa`, p) // 出库
export const checkConfirmWhOutstockJanFa = p => post(`${name}/tEmptyForJanFa/checkConfirmWhOutstockJanFa`, p) // 出库

export const getJCFeeList = p => post(`${name}/storageFee/getJCFeeList`, p) // 费用明细列表查询:
export const getJCFeeAllfee = p => post(`${name}/storageFee/getJCFeeAllfee`, p) // 费用明细列表合计:
export const addJCFee = p => post(`${name}/storageFee/addJCFee`, p) // 建材账单管理添加提交
export const deleteJCFeeMaster = p => post(`${name}/storageFee/deleteJCFeeMaster`, p) // 建材账单管理删除
export const finishJCFee = p => post(`${name}/storageFee/finishJCFee`, p) // 建材账单管理结算完成

// 统计汇总
export const getInUnloadingList = p => post(`${name}/whInOutStockCargoRecord/getInUnloadingList`, p) // 入库卸车汇总
export const getCustomerPushList = p => post(`${name}/whInOutStockCargoRecord/getCustomerPushList`, p) // 客户库存
// 仓库管理移库
export const transferLibraryList = p => post(`${name}/whOperationManage/transferLibraryList`, p) // 客户库存
// 建发监管-库存查看or记录
export const getSupervisorStockList = p => post(`${name}/supervisorForJanFa/getSupervisorStockList`, p) // 客户库存
export const getSupervisorStockListNumber = p => post(`${name}/supervisorForJanFa/getSupervisorStockListNumber`, p) // 客户库存

export const getSupervisorInStockList = p => post(`${name}/supervisorForJanFa/getSupervisorInStockList`, p)
export const getSupervisorInStockListNumber = p => post(`${name}/supervisorForJanFa/getSupervisorInStockListNumber`, p)
export const getSupervisorOutStockList = p => post(`${name}/supervisorForJanFa/getSupervisorOutStockList`, p)
export const getSupervisorOutStockListNumber = p => post(`${name}/supervisorForJanFa/getSupervisorOutStockListNumber`, p)
export const getSupervisorCustomerChangesList = p => post(`${name}/supervisorForJanFa/getSupervisorCustomerChangesList`, p)
export const getSupervisorCustomerChangesListNumber = p => post(`${name}/supervisorForJanFa/getSupervisorCustomerChangesListNumber`, p)

export const updateJCPayCustomer = p => post(`${name}/storageFee/updateJCPayCustomer`, p) // 仓储结算-费用明细-建材：增加修改结算客户功能
export const changePushCustomer = p => post(`${name}/whOperationManage/changePushCustomer`, p) // 库存管理————修改钢厂推送货主
// 监管盘库
export const importJBInventoryGoods = p => post(`${name}/inventory/importJBInventoryGoods`, p) // 导入卷板货物
export const importJCInventoryGoods = p => post(`${name}/inventory/importJCInventoryGoods`, p) // 导入建材货物
export const addNewInventoryList = p => post(`${name}/inventory/addNewInventoryList`, p) // 新建盘库
export const getJGInventoryGoodsList = p => post(`${name}/inventory/getJGInventoryGoodsList`, p) // 监管盘库订单货物列表查询
export const JGfinishInventoryList = p => post(`${name}/inventory/JGfinishInventoryList`, p) // 盘库结束
export const deleteJGInventoryList = p => post(`${name}/inventory/deleteJGInventoryList`, p) // 删除
export const getJGInventoryOrderList = p => post(`${name}/inventory/getJGInventoryOrderList`, p) // 监管盘库主表
export const getUserPathWeb = p => post(`${name}/inventory/getUserPathWeb`, p) // 监管盘库轨迹回放
export const jGExamine = p => post(`${name}/inventory/jGExamine`, p) // 监管审核

// 二次分货-待确认-进仓确认弹窗费用列表查询
export const getConfirmGoodsFeeList = p => post(`${name}/distributionGoods/getConfirmGoodsFeeList`, p)
// 仓储结算
export const getTMonthlyStatementConfig = p => post(`${name}/tMonthlyStatementConfig/getTMonthlyStatementConfig`, p)
export const getTMonthlyStatementConfigAdd = p => post(`${name}/tMonthlyStatementConfig/add`, p)
export const getTMonthlyStatementConfigUpdate = p => post(`${name}/tMonthlyStatementConfig/update`, p)
// 每日库存
export const getDailyCustomerList = p => post(`${name}/daily/getDailyCustomerList`, p)
export const getDailyCustomerNumber = p => post(`${name}/daily/getDailyCustomerNumber`, p)
export const addEmptyChangeDaily = p => post(`${name}/daily/addEmptyChangeDaily`, p)
export const clearDailyStock = p => post(`${name}/daily/clearDailyStock`, p)
export const importDailyCustomers = p => post(`${name}/daily/importDailyCustomers`, p)
export const transferDaily = p => post(`${name}/daily/transferDaily`, p)
export const importDailyStock = p => post(`${name}/daily/importDailyStock`, p)
// 出库明细+转货明细—+入库亏涨记录wmsStock/daily/importDailyStock
export const getOutList = p => post(`${name}/stockExpInfo/getOutList`, p)
export const revokeInChange = p => post(`${name}/stockExpInfo/revokeInChange`, p)
export const getInChangeNumber = p => post(`${name}/stockExpInfo/getInChangeNumber`, p)
export const getOutNumber = p => post(`${name}/stockExpInfo/getOutNumber`, p)
export const getInChangeList = p => post(`${name}/stockExpInfo/getInChangeList`, p)
export const getInLowOrHighList = p => post(`${name}/stockExpInfo/getInLowOrHighList`, p)

// 查询出库计划货物信息按入库日期的列表
export const getOutstockStockSummaryList = p => post(`${name}/tEmptyForJanFa/getOutstockStockSummaryList`, p)
export const getNewOutstockStockSummaryList = p => post(`${name}/tEmptyForJanFa/getNewOutstockStockSummaryList`, p)
// 结算货主
export const getSettlementOwnerList = p => post(`${name}/storageFee/getSettlementOwnerList`, p)
export const addSettlementOwner = p => post(`${name}/storageFee/addSettlementOwner`, p)
export const DelSettlementOwnerList = p => post(`${name}/storageFee/DelSettlementOwnerList`, p)

// 鸿远库出库提单，计划
// 出库提单 添加出库计划 添加货物列表车船号查询下拉框
export const getDailyStockOfVehicleNumber = p => post(`${name}/tEmptyForJanFaHongYuan/getDailyStockOfVehicleNumber`, p)
// 添加出库计划 添加货物列表货主转货单号查询下拉框
export const getDailyStockOfCustomerChangeNo = p => post(`${name}/tEmptyForJanFaHongYuan/getDailyStockOfCustomerChangeNo`, p)
// 出库提单 添加出库计划 添加货物列表
export const getDailyStockSummaryList = p => post(`${name}/tEmptyForJanFaHongYuan/getDailyStockSummaryList`, p)
// 出库提单添加出库计划确定
export const addEmptyOutstockJanFaHyForBill = p => post(`${name}/tEmptyForJanFaHongYuan/addEmptyOutstockJanFaHyForBill`, p)
// 出库计划出库单删除货物明细(删除出库单上每日库存明细)
export const delTEmptyOutstockStockSummaryJanFaHy = p => post(`${name}/tEmptyForJanFaHongYuan/delTEmptyOutstockStockSummaryJanFaHy`, p)
// 出库计划 添加出库计划 添加货物列表车船号查询下拉框
export const getDailyStockOfVehicleNumberForPlan = p => post(`${name}/tEmptyForJanFaHongYuan/getDailyStockOfVehicleNumberForPlan`, p)
// 出库计划 添加出库计划 添加货物列表货主转货单号查询下拉框
export const getDailyStockOfCustomerChangeNoForPlan = p => post(`${name}/tEmptyForJanFaHongYuan/getDailyStockOfCustomerChangeNoForPlan`, p)
// 出库计划 添加出库计划 添加货物列表规格查询下拉框
export const getDailyStockOfSpecificationForPlan = p => post(`${name}/tEmptyForJanFaHongYuan/getDailyStockOfSpecificationForPlan`, p)
// 出库计划 添加出库计划 添加货物列表(每日库存)
export const getDailyStockSummaryListForPlan = p => post(`${name}/tEmptyForJanFaHongYuan/getDailyStockSummaryListForPlan`, p)
// 出库计划添加出库计划确定
export const addEmptyOutstockJanFaHyForPlan = p => post(`${name}/tEmptyForJanFaHongYuan/addEmptyOutstockJanFaHyForPlan`, p)
// 查询出库单主表子表所有信息（确认出库回显用）
export const getOutstockInfoJanFaHyForConfirm = p => post(`${name}/tEmptyForJanFaHongYuan/getOutstockInfoJanFaHyForConfirm`, p)
// 宁波鸿远库确认出库，费用列表展示
export const getStorageFeeListForHy = p => post(`${name}/tEmptyForJanFaHongYuan/getStorageFeeListForHy`, p)
// 出库计划页面 确认出库&结算出库
export const confirmWhOutstockJanFaHy = p => post(`${name}/tEmptyForJanFaHongYuan/confirmWhOutstockJanFaHy`, p)
// 出库计划页面 确认出库&结算出库。查验
export const checkConfirmWhOutstockJanFaHy = p => post(`${name}/tEmptyForJanFaHongYuan/checkConfirmWhOutstockJanFaHy`, p)

// 兴瀚出库提单
export const queryWayList = p => post(`${name}/tmsOut/queryWayList`, p)
export const queryWayGoodsList = p => post(`${name}/tmsOut/queryWayGoodsList`, p)
export const queryWayGoodsWeight = p => post(`${name}/tmsOut/queryWayGoodsWeight`, p)
export const createOutPlan = p => post(`${name}/tmsOut/createOutPlan`, p)
export const sendsOutPlan = p => post(`${name}/tmsOut/sendsOutPlan`, p)
// 转货记录备注添加修改
export const operationChangeRecordRemarks = p => post(`${name}/stockExpInfo/operationChangeRecordRemarks`, p)
// 出库记录
export const operationOutStockRecordRemarks = p => post(`${name}/stockExpInfo/operationOutStockRecordRemarks`, p)
// 仓位维护-进仓跳转页面
export const getbcUrl = p => post(`${name}/warehouse/getbcUrl`, p)
// 盘库删除货物
export const deleteInventoryDetail = p => post(`${name}/inventory/deleteInventoryDetail`, p)
export const callSettlementMethod = p => post(`${name}/tmsOut/callSettlementMethod`, p)
export const getFeeMode = p => post(`${name}/tmsOut/getFeeMode`, p)
export const deleteWayList = p => post(`${name}/tmsOut/deleteWayList`, p) // 出库提单删除未完成单子

export const findNewJfInstockNo = p => post(`${name}/change/findNewJfInstockNo`, p)

// 天车日志
export const intelligenceList = p => post(`/${wmsCenter}/t/wh/warehouse/intelligenceList`, p) // 智能仓库接口
export const queryJob = p => post(`/${wmsCenter}/wmsApi/sw/queryJob`, p) // 智能仓库接口
// 加工-郭凡设计

export const goodsCodeList = p => post(`${name}/t/goods/code/goodsCodeList`, p) // 查询
export const addGoodcode = p => post(`${name}/t/goods/code/addGoodcode`, p) // 添加
export const updateGoodsCode = p => post(`${name}/t/goods/code/updateGoodsCode`, p) // 修改
export const deleteGoodcode = p => post(`${name}/t/goods/code/deleteGoodcode`, p) // 删除
export const overUse = p => post(`${name}/t/goods/code/overUse`, p) // 终止使用
// 到货计划
export const getArrivalPlanList = p => post(`${name}/arrivalPlan/getArrivalPlanList`, p) // 到货计划信息列表
export const addArrivalPlan = p => post(`${name}/arrivalPlan/addArrivalPlan`, p) // 添加到货计划
export const updateArrivalPlan = p => post(`${name}/arrivalPlan/updateArrivalPlan`, p) // 修改到货计划
export const deleteArrivalPlan = p => post(`${name}/arrivalPlan/deleteArrivalPlan`, p) // 删除到货计划
export const accomplishArrivalPlan = p => post(`${name}/arrivalPlan/accomplishArrivalPlan`, p) // 完成到货计划
export const addChangesRemark = p => post(`${name}/change/addChangesRemark`, p) // 变更履历-修改备注
export const addOutRemark = p => post(`${name}/whInOutStockCargoRecord/addOutRemark`, p) // 出库记录-修改备注
export const cancelCheckDistribution = p => post(`${name}/machiningExp/cancelCheckDistribution`, p) // 加工2.0 验收-撤销
export const tProcessStatementMonthList = p => post(`${name}/tProcessStatementMonth/list`, p) // 加工月账单结算
export const getStatementInfoList = p => post(`${name}/tProcessStatementMonth/getStatementInfoList`, p) // 加工月账单结算单号列表
export const getDailyCustomerStock = p => post(`${name}/daily/getDailyCustomerStock`, p) // 每日库存转货
// 查看兴瀚库11号库标仓开关状态
export const bcSwitchInfo = p => post(`${name}/warehouse/bcSwitchInfo`, p)

// 兴瀚库11号库标仓开关
export const bcSwitch = p => post(`${name}/warehouse/bcSwitch`, p)
export const updateSalesSelfNumber = p => post(`${name}/whOperationManage/updateSalesSelfNumber`, p)
// 首钢订单
export const getSgOrderList = p => post(`${name}/tXhSgOrder/getSgOrderList`, p)// 列表查询
export const deleteSgOrder = p => post(`${name}/tXhSgOrder/deleteSgOrder`, p)// 删除首钢订单
export const accomplishSgOrder = p => post(`${name}/tXhSgOrder/accomplishSgOrder`, p)// 完成首钢订单
export const importXhSgOrder = p => post(`${name}/tXhSgOrder/importXhSgOrder`, p)// 完成首钢订单

// 业务管理
export const getBusinessManagementList = p => post(`${name}/businessManagement/getBusinessManagementList`, p)// 查询业务管理列表
export const addBusinessManagement = p => post(`${name}/businessManagement/addBusinessManagement`, p)// 新增业务管理
export const updateBusinessManagement = p => post(`${name}/businessManagement/updateBusinessManagement`, p)// 修改业务管理
export const deleteBusinessManagement = p => post(`${name}/businessManagement/deleteBusinessManagement`, p)// 删除业务管理
export const getBusinessManagementDetailList = p => post(`${name}/businessManagement/getBusinessManagementDetailList`, p)// 查询业务管理的业务追踪
export const updateBusinessManagementDetail = p => post(`${name}/businessManagement/updateBusinessManagementDetail`, p)// 修改业务追踪
export const getBusinessManagementGoodsList = p => post(`${name}/businessManagement/getBusinessManagementGoodsList`, p)// 查询业务管理货物列表
export const importBusinessManagementGoods = p => post(`${name}/businessManagement/importBusinessManagementGoods`, p)// 查询业务管理货物列表
export const businessUploadCredentials = p => post(`${name}/businessManagement/businessUploadCredentials`, p)// 查询业务管理货物列表
export const getBusinessCredentials = p => post(`${name}/businessManagement/getBusinessCredentials`, p)// 查询业务管理货物列表
export const deleteBusinessCredentials = p => post(`${name}/businessManagement/deleteBusinessCredentials`, p)// 查询业务管理货物列表

export const driverVehicleInList = (p) => post(`${name}/driverVehicleInformation/getDriverVehicleInList`, p)
export const markDriverVehicle = (p) => post(`${name}/driverVehicleInformation/markDriverVehicleIn`, p)
export const deleteDriverVehicle = (p) => post(`${name}/driverVehicleInformation/deleteDriverVehicleIn`, p)
export const detailByIDDriverVehicle = (p) => post(`${name}/driverVehicleInformation/detail`, p)
export const detailByPlateNumberDriverVehicle = (p) => post(`${name}/driverVehicleInformation/getDriverVehicleInfo`, p)
// 天车工管理
export const getCranemanList = (p) => post(`${name}/craneman/getCranemanList`, p)// 天车工列表
export const deleteCraneman = (p) => post(`${name}/craneman/deleteCraneman`, p)// 天车工删除
export const machiningCaList = (p) => post(`${name}/machiningAcceptanceCancelRecord/list`, p)// 加工-撤销记录
export const printBill = (p) => post(`${name}/bill/printBill`, p)// 提单作业-打印
// 兴瀚卷控货需求
export const operateLockCargo = (p) => post(`${name}/whOperationManage/operateLockCargo`, p)
export const operateUnlockCargo = (p) => post(`${name}/whOperationManage/operateUnlockCargo`, p)
export const lockCargoLogList = (p) => post(`${name}/lockCargoLog/list`, p)
export const oCrAnalysis = (p) => post(`${name}/tWhImg/oCrAnalysis`, p)// 获取ocr选项
export const findOcrCargoList = (p) => post(`${name}/bill/findOcrCargoList`, p)// 获取ocr选项
export const addChangeDetaiFilel = (p) => post(`${name}/change/addChangeDetaiFilel`, p)// 获取ocr选项
export const findOcrChangeCargoList = (p) => post(`${name}/change/findOcrChangeCargoList`, p)// 获取ocr选项

// 仓储结算-费用明细-卷板 修改单价
export const sFUpdateUnitPrice = (p) => post(`${name}/storageFee/updateUnitPrice`, p)// 获取ocr选项
// 获取变更-变更作业-查询货权变更主表货主端来源待处理条数
export const findChangeMasterNu = (p) => post(`${name}/change/findChangeMasterNu`, p)
// 3PL反馈-货权变更反馈-修改结算客户
export const updateChangePay = (p) => post(`${name}/pl3Stock/updateChangePay`, p)

// 提单获取结算部门20240605
export const getPayDepartment = p => post(`/${name}/bill/getPayDepartment`, p)

// 仓储结算账单管理 查看卷板账单凭证
export const getBillVoucherReel = p => post(`/${name}/storageFee/getBillVoucherReel`, p)
// 仓储结算账单管理 上传卷板账单凭证
export const saveBillVoucherReel = p => post(`/${name}/storageFee/saveBillVoucherReel`, p)

//  板入库-ocr
export const oCrZhbDetail = p => post(`/${name}/instock/oCrZhbDetail`, p)

//  客户颜色配置
export const findCustomerColourList = p => post(`/${name}/bCustomerColour/findCustomerColourList`, p)// 列表
export const deleteCustomerColour = p => post(`/${name}/bCustomerColour/deleteCustomerColour`, p)// 删除
export const updateCustomerColour = p => post(`/${name}/bCustomerColour/updateCustomerColour`, p)// 修改
export const addCustomerColour = p => post(`/${name}/bCustomerColour/addCustomerColour`, p)// 添加

//  客户仓位配置
export const findWarehouseCustomerList = p => post(`/${name}/tWarehouseCustomerDisposition/findWarehouseCustomerList`, p)// 列表
export const findWarehouseCustomerListYh = p => post(`/${name}/tWarehouseCustomerDisposition/findWarehouseCustomerListYh`, p)// 列表
export const findAvailableWarehouseCustomerList = p => post(`/${name}/tWarehouseCustomerDisposition/findAvailableWarehouseCustomerList`, p)// 查询现有仓位客户配置数据
export const deleteWarehouseCustomerListYh = p => post(`/${name}/tWarehouseCustomerDisposition/deleteWarehouseCustomerListYh`, p)// 删除
export const updateWarehouseCustomerYh = p => post(`/${name}/tWarehouseCustomerDisposition/updateWarehouseCustomerYh`, p)// 修改
export const addWarehouseCustomerYh = p => post(`/${name}/tWarehouseCustomerDisposition/addWarehouseCustomerYh`, p)// 添加
// 提单作业-自助配货
export const selfDispensing = p => post(`/${name}/terminal/selfDispensing`, p)
// 建发客户库存-加工
export const coalProcess = p => post(`/${name}/stockThreadExp/coalProcess`, p)
// 建发客户库存-库存调整
export const inventoryAdjustment = p => post(`/${name}/stockThreadExp/inventoryAdjustment`, p)
// 建发客户库存-盘盈盘亏
export const clearStockCustomerCoal = p => post(`/${name}/stockThreadExp/clearStockCustomerCoal`, p)
// 建发仓库库存库存-盘盈盘亏
export const clearStockWarehouseCoal = p => post(`/${name}/stockThreadExp/clearStockWarehouseCoal`, p)
// 仓储合同
export const findWarehouseContractList = p => post(`/${name}/warehouseContract/findWarehouseContractList`, p)// 合同列表
export const addWarehouseContract = p => post(`/${name}/warehouseContract/addWarehouseContract`, p)// 合同列表新增
export const deleteWarehouseContract = p => post(`/${name}/warehouseContract/deleteWarehouseContract`, p)// 合同列表删除
export const getWarehouseContractInfo = p => post(`/${name}/warehouseContract/getWarehouseContractInfo`, p)// 合同列表信息
export const getWarehouseContractFlie = p => post(`/${name}/warehouseContract/getWarehouseContractFlie`, p)// 合同附件
export const updateWarehouseContract = p => post(`/${name}/warehouseContract/updateWarehouseContract`, p)// 合同修改

export const changeCounterfeitFeedback = p => post(`/${name}/pl3Stock/changeCounterfeitFeedback`, p)// 货权变更反馈-虚反馈

// 建发出库单据-上传磅单
export const saveOutStockReceipt = p => post(`/${name}/tEmptyForJanFaWeChat/saveOutStockReceipt`, p)
// 建发出库单据-查看磅单
export const getOutStockReceip = p => post(`/${name}/tEmptyForJanFaWeChat/getOutStockReceipt`, p)
// 排号系统进仓登记页面创建计划，查询最新一条数据
export const findInPlan = p => post(`/${wmsCenter}/queue/findInPlan`, p)
//= =cosco搬过来的接口==============
// 入库单据-修改入库时间接口
export const changeInstockDate = p => post(`${name}/stockThread/changeInstockDate`, p)
export const getTEmptyBillMasterForListZY = p => post(`${name}/tEmpty/getTEmptyBillMasterForList`, p)
// 出库提单-货物明细列表
export const getTEmptyBillDetailList = p => post(`${name}/tEmpty/getTEmptyBillDetailList`, p)
// 出库提单-作废
export const cancelTEmptyBillMaster = p => post(`${name}/tEmpty/cancelTEmptyBillMaster`, p)
// 出库提单-完成
export const completeTEmptyBillMaster = p => post(`${name}/tEmpty/completeTEmptyBillMaster`, p)
// 出库提单-货物类型下拉框
export const getEmptyBillDetailGroup = p => post(`${name}/tEmpty/getEmptyBillDetailGroup`, p)
// 出库提单-添加货物
export const getEmptyBillStockSummary = p => post(`${name}/tEmpty/getEmptyBillStockSummary`, p)
// 出库提单-添加货物确定
export const addEmptyOutstock = p => post(`${name}/tEmpty/addEmptyOutstock`, p)
export const delEmptyBillDetail = p => post(`/${name}/tEmpty/delEmptyBillDetail`, p)
export const getEmptyBillStockSummarySD = p => post(`/${name}/tEmpty/getEmptyBillStockSummarySD`, p)
export const getTEmptyBillDriverList = p => post(`/${name}/tEmpty/getTEmptyBillDriverList`, p)
export const findEmptyBillDriverList = p => post(`/${name}/tEmpty/findEmptyBillDriverList`, p) // 查询车辆司机信息
export const cVirtualControlList = p => post(`/${stockname}/sVirtualControlRecord/cVirtualControlList`, p) // 控货接口、
export const virtualControlBeanZy = p => post(`/${signature}/api/control/virtualControlBeanZy`, p)// 查询具体一种控货的统计数据(中远)
// 区位
export const getEmptyBillStockLocationInfo = p => post(`/${name}/tEmptyForJanFa/getEmptyBillStockLocationInfo`, p)
export const getEmptyBillStockWarehouseInfo = p => post(`/${name}/tEmptyForJanFa/getEmptyBillStockWarehouseInfo`, p)
export const getNumberForBillStockWarehouse = p => post(`/${name}/tEmptyForJanFa/getNumberForBillStockWarehouse`, p)
export const getCusAvNuExp = p => post(`/${name}/tEmpty/getCustomerAvailableNumberExp`, p) // 客户可提
export const getTEmptyStockCustomerGroupExp = p => post(`/${name}/tEmptyForJanFa/getTEmptyStockCustomerGroupExp`, p)
export const addEmptyBillDetail = p => post(`/${name}/tEmpty/addEmptyBillDetail`, p)
export const addEmptyBillDetailExpZy = p => post(`/${name}/tEmpty/addEmptyBillDetailExpZy`, p) // 出库提单 添加货物-保存
export const addEmptyBillDetailExp = p => post(`/${name}/tEmpty/addEmptyBillDetailExp`, p) // 添加货物-保存
export const getCustomerForBill = p => post(`/${name}/tEmpty/getCustomerForBill`, p) // 添加货物-客户库存
export const deleteEmptyBillDriver = p => post(`/${name}/tEmpty/deleteEmptyBillDriver`, p) // 删除车辆司机信息
export const operationEmptyBillDriverList = p => post(`/${name}/tEmpty/operationEmptyBillDriverList`, p) // 新增修改车辆司机信息
export const getEmptyBillStockWarehouse = p => post(`/${name}/tEmptyForJanFa/getEmptyBillStockWarehouse`, p) // 添加货物-仓位库存
export const addEmptyBillMaster = p => post(`/${name}/tEmpty/addEmptyBillMaster`, p)
export const addEmptyOutstockExp = p => post(`/${name}/tEmpty/addEmptyOutstockExp`, p) // 添加书库计划确定
// 出库记录-列表查询
export const getOutStockThreadList = p => post(`${name}/stockThread/getOutStockThreadList`, p)
// 出库记录-撤销
// export const deleteOutStockThread = p => post(`${name}/stockThread/deleteOutStockThread`, p)
export const deleteOutStockThread = p => post(`${name}/stockThread/deleteOutStockThreadZy`, p)
export const getOutStockThreadWeightNumber = p => post(`/${name}/stockThread/getOutStockThreadWeightNumber`, p) // 出库总重量
// 撤销记录-列表查询
export const getDeleteOutStockThreadList = p => post(`${name}/stockThread/getDeleteOutStockThreadList`, p)
export const getCustomerClearListZy = p => post(`/${name}/stockExpInfo/getCustomerClearListZy`, p) // 客户清零记录列表查询2.0
export const getCustomerClearWeightNumber = p => post(`/${name}/stockExpInfo/getCustomerClearWeightNumber`, p) // 客户清零记录总重量总件数2.0
export const addEmptyChangeZy = p => post(`/${name}/stockThread/addEmptyChangeZy`, p) // 客户库存2.货权方转货
export const clearStockCustomer = p => post(`${name}/stockThreadExp/clearStockCustomer`, p)
export const getStockCustomerWN = p => post(`/${name}/stockThreadExp/getStockCustomerWN`, p) // 客户库存列表-吨数
export const addEmptyChangeForOwnerZy = p => post(`/${name}/stockThread/addEmptyChangeForOwnerZy`, p) // 客户库存2.0转货申请保存
export const getCustomerAvailableNumberExp = p => post(`/${name}/tEmpty/getCustomerAvailableNumberExp`, p) // 客户库存可提件数
export const addEmptyChangeZyKh = p => post(`/${name}/stockThread/addEmptyChangeZyKh`, p) // 客户库存2.货权方转货
// 删除记录-列表查询
export const getDeleteInStockThreadList = p => post(`${name}/stockThread/getDeleteInStockThreadList`, p)
export const getTransferRecordListZY = p => post(`/${name}/stockThread/getTransferRecordList`, p) // 移库
// 入库记录-列表查询
export const getInStockThreadList = p => post(`${name}/stockThread/getInStockThreadList`, p)
// 入库记录-删除
export const deleteInStockThread = p => post(`${name}/stockThread/deleteInStockThreadZy`, p)
export const deleteInStockThreadZy2 = p => post(`/${name}/stockThread/deleteInStockThreadZy2`, p) // 入库记录-删除
export const getInStockThreadWeightNumber = p => post(`/${name}/stockThread/getInStockThreadWeightNumber`, p) // 入库总重量
export const updateInRemark = p => post(`/${name}/stockThread/updateInRemark`, p) // 入库记录-修改备注
export const updateInstockPlateNumber = p => post(`/${name}/stockThread/updateInstockPlateNumber`, p) // 入库记录-修改车牌号
export const updateTransferExternalNo = p => post(`/${name}/tEmpty/updateTransferExternalNo`, p) // 修改转货外部单号
export const updateInExternalNo = p => post(`/${name}/stockThread/updateInExternalNo`, p) // 修改入库外部单号
export const getWarehouseClearWeightNumber = p => post(`/${name}/stockExpInfo/getWarehouseClearWeightNumber`, p) // 仓位清零记录总重量总件数2.0
// 仓位库存优先标记
export const addMoveUpMark = p => post(`/${name}/stockWarehouse/addMoveUpMark`, p)
// 仓位库存取消优先标记
export const deleteMoveUpMark = p => post(`/${name}/stockWarehouse/deleteMoveUpMark`, p)
export const getTEmptyChangeMasterList = p => post(`/${name}/tEmpty/getTEmptyChangeMasterList`, p)
export const getTEmptyChangeDetailList = p => post(`/${name}/tEmpty/getTEmptyChangeDetailList`, p)
export const changeExamineExp = p => post(`/${name}/tEmpty/changeExamineExp`, p) // 转货审核-审核确认
export const deleteTEmptyChangeMaster = p => post(`/${name}/tEmpty/deleteTEmptyChangeMaster`, p)
export const delTEmptyChangeDetail = p => post(`/${name}/tEmpty/delTEmptyChangeDetail`, p)
export const updateTEmptyChangeDetail = p => post(`/${name}/tEmpty/updateTEmptyChangeDetail`, p)
export const getEmptyChangeRecordList = p => post(`/${name}/tEmpty/getEmptyChangeRecordList`, p)
export const changeExamineExpZy = p => post(`/${name}/tEmpty/changeExamineExpZy`, p) // 转货审核
export const getStockCustomerList = p => post(`${name}/stockThreadExp/getStockCustomerExpList`, p) // 客户库存列表
export const JfgetStockWarehouseListZY = p => post(`/${name}/stockThreadExp/getStockWarehouseListZy`, p) // 仓位库存列表查询
export const JftransferStockThreadZY = p => post(`/${name}/stockThreadExp/transferStockThreadZy`, p) // 仓位库存移库
//= =cosco搬过来的接口结束==============
